document.addEventListener('click', (event) => {
  const button = event.target.closest('button[name="checkout"][form="cart"]');
  if (!button) return;
  const checkbox = document.getElementById('cp-installation-ack');
  if (!checkbox?.checked) {
    const error = document.getElementById('cp-installation-error');
    if (error) error.hidden = false;
    checkbox?.focus();
  }
});
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (form.id !== 'cart' || event.submitter?.name !== 'checkout') return;
  if (form.dataset.cpAckSaved === 'true') return;
  event.preventDefault();
  const checkbox = document.getElementById('cp-installation-ack');
  const error = document.getElementById('cp-installation-error');
  if (!checkbox?.checked) {
    if (error) error.hidden = false;
    checkbox?.focus();
    return;
  }
  const button = event.submitter;
  button.disabled = true;
  try {
    if (!window.CPGifts || !await window.CPGifts.ensureReady()) {
      button.disabled = false;
      if (error) { error.textContent = 'Please choose your free Scratch Shield for each qualifying build before checkout. If choices are still loading, try again shortly.'; error.hidden = false; }
      return;
    }
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify({attributes: {
        'Installation acknowledgment': checkbox.value,
        'Installation acknowledgment time': new Date().toISOString()
      }})
    });
    if (!response.ok) throw new Error('Unable to save acknowledgment');
    form.dataset.cpAckSaved = 'true';
    button.disabled = false;
    form.requestSubmit(button);
  } catch (failure) {
    button.disabled = false;
    if (error) { error.textContent = 'We could not save your acknowledgment. Please try again.'; error.hidden = false; }
  }
});
